import React from 'react';
import PageTemplate from '../../components/PageTemplate';
const AnalyticsBI = () => {
  return <PageTemplate title="Analytics & BI" subtitle="Business Intelligence Solutions" breadcrumb="AI & Data > Analytics & BI"><div className="content-section"><p>Data visualization, predictive analytics, and business intelligence services.</p></div></PageTemplate>;
};
export default AnalyticsBI; 